import React, { useEffect, useState } from "react"
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { debug } from "../utils";
import { login, setupNewToken, setupUserCapabilities } from "./authService";
import { showSuccessToast, showDangerToast } from "../validation/ToastContainer"; // Changed from showErrorToast
import { Person, Lock } from '@mui/icons-material';

export function LoginPage({ access_token, referer }) {

    const [username, _setUsername] = useState("");
    const [password, _setPassword] = useState("");
    //const [rememberMe, setRememberMe] = useState(false);
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({ username: false, password: false });

    // in document event listener react state in not accessible. We need to create refs
    const usernameRef = React.useRef(username);
    const passwordRef = React.useRef(password);
    const passwordInputRef = React.useRef(null);

    const [localEnableOtp, setLocalEnableOtp] = useState(false);
    const [redirectToOtp, setRedirectToOtp] = useState(false);
    const redirectTarget = referer && !["/login", "/otp"].includes(referer) ? referer : "/";


    const setUsername = data => {
        usernameRef.current = data;
        _setUsername(data);
        // Clear error when user starts typing
        if (errors.username && data.trim()) {
            setErrors(prev => ({ ...prev, username: false }));
        }
    };
    
    const setPassword = data => {
        passwordRef.current = data;
        _setPassword(data);
        // Clear error when user starts typing
        if (errors.password && data.trim()) {
            setErrors(prev => ({ ...prev, password: false }));
        }
    };

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Enter') {
                const usernameValue = usernameRef.current.trim();
                const passwordValue = passwordRef.current.trim();

                if (usernameValue && !passwordValue && document.activeElement?.id === "username") {
                    event.preventDefault();
                    passwordInputRef.current?.focus();
                    return;
                }

                if (usernameValue && passwordValue) {
                    event.preventDefault();
                    handleSubmit();
                }
            }
        };

        document.addEventListener("keydown", handleKeyDown);

        return () => {
            document.removeEventListener("keydown", handleKeyDown);
        };

        /* eslint-disable react-hooks/exhaustive-deps */
    }, []);


    const handleSubmit = () => {
        if(loading) return;

        const currentUsername = usernameRef.current;
        const currentPassword = passwordRef.current;
        
        // Validate form before submitting - This will handle cases where someone
        // removes the disabled attribute via dev tools
        const isUsernameValid = currentUsername.trim().length > 0;
        const isPasswordValid = currentPassword.trim().length > 0;
        
        if (!isUsernameValid || !isPasswordValid) {
            if (!isUsernameValid && !isPasswordValid) {
                showDangerToast("Please enter username and password", "Validation Error");
            } else if (!isUsernameValid) {
                showDangerToast("Please enter username", "Validation Error");
            } else {
                showDangerToast("Please enter password", "Validation Error");
            }
            
            // Set visual errors (if need this to displau uncomment from the UI of fields)
            setErrors({
                username: !isUsernameValid,
                password: !isPasswordValid
            });
            
            return;
        }
        
        setLoading(true);
        login(currentUsername, currentPassword, false)
            .then(async (response) => {
                setPassword("");
                if (!response.enableOTP) {
                    await setupNewToken(response.access_token, response.userCapability, false);
                    showSuccessToast("Successfully Signed In", "Sign In");
                }
                else {
                    await setupUserCapabilities(response.access_token, response.userCapability, false);
                    setLocalEnableOtp(true)
                    //window.location.href = "/otp";
                }

            })
            .catch((error) => {
                // console.error(error);
            })
            .finally(() => {
            setLoading(false);     // stop loading (success or error)
        });

    }

    // const onChange = (value) => {
    //     setRememberMe(value);
    // }

    // useEffect(() => {
    //     if (access_token) {
    //         if (enableOtp) {
    //             createOTP().then(otp => {
    //                 sendOtpToMail(otp, userMail);
    //                 setSessionOtp(otp);
    //                 setRedirectToOtp(true); // trigger redirect
    //             });
    //         } 
    //         else {
    //             showSuccessToast("Successfully signed in", "Sign in");
    //         }
    //     }
    // }, [access_token, enableOtp]);

    useEffect(() => {
        async function checkSendOTP(){
            if (localEnableOtp) {
                setRedirectToOtp(true);
            }
        }

        checkSendOTP();

    }, [localEnableOtp]);

    if (access_token && !localEnableOtp) {
        return <Redirect to={redirectTarget} />;
        //return <Redirect to={"/"} />;
    }

    if (redirectToOtp) {
        return <Redirect to={"/otp"} />;
    }

    // Check if form is valid for button styling only
    const isFormValid = username.trim() && password.trim();


    return (
        <div className="hold-transition login-page-v2">
            {/* Decorative Background Elements */}
            <div className="decorative-background-v2">
                <div className="decorative-circle-v2 circle-1"></div>
                <div className="decorative-circle-v2 circle-2"></div>
            </div>

            <div className="login-container-v2">
                {/* Login Card */}
                <div className="login-card-v2">
                    {/* Logo - Top Center */}
                    <div className="logo-container-v2">
                        <img src={`${process.env.PUBLIC_URL}/octopus-logo.svg`} alt="Octopus Cybersecurity" className="logo-img-v2" />
                    </div>

                    {/* Header */}
                    <div className="login-header-v2">
                        <h2>Octopus VAR</h2>
                    </div>

                    {/* Login Form */}
                    <div className="login-form-v2">
                        {/* Username Input */}
                        <div className="form-group-v2">
                            <label htmlFor="username">
                                Username<span className="required-star">*</span>
                            </label>
                            <div className="input-wrapper-v2">
                                <div className="icon-wrapper-v2">
                                    <Person className="login-icon"/>
                                </div>
                                <input
                                    id="username"
                                    type="text"
                                    value={username}
                                    onChange={(e) => setUsername(e.target.value)}
                                    placeholder="Username *"
                                    className={`form-control-v2 ${errors.username ? 'error-field' : ''}`}
                                    required
                                />
                            </div>
                            {/* {errors.username && <div className="error-message">Username is required</div>} */}
                        </div>

                        {/* Password Input */}
                        <div className="form-group-v2">
                            <label htmlFor="password">
                                Password<span className="required-star">*</span>
                            </label>
                            <div className="input-wrapper-v2">
                                <div className="icon-wrapper-v2">
                                    <Lock className="login-icon"/>
                                </div>
                                <input
                                    id="password"
                                    ref={passwordInputRef}
                                    type="password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    placeholder="Password *"
                                    className={`form-control-v2 ${errors.password ? 'error-field' : ''}`}
                                    required
                                />
                            </div>
                            {/* {errors.password && <div className="error-message">Password is required</div>} */}
                        </div>

                        {/* Sign In Button */}
                        <button
                            type="button"
                            disabled={!isFormValid || loading}
                            onClick={(e) => {
                                e.preventDefault();
                                handleSubmit();
                            }}
                            className={`btn-login-v2 ${!isFormValid ? 'btn-disabled' : ''}`}
                        >
                            {loading ? "Signing In..." : "Sign In"}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

function mapStateToProps(state) {
    debug("LoginPage mapStateToProps", state);
    return {
        access_token: state.auth.access_token,
        referer: state.auth.referer
    };
}

export default connect(mapStateToProps)(LoginPage);
